iScreenWizard.factory('Testafname', function ($q, Ajax, Groepscode) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('testafname', params).then(function (response) {
                var testtypes = response.data;
                resolve(testtypes);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('testafname/'+id).then(function (response) {
                var testtype = response.data;
                resolve(testtype);
            }, reject);
        });
    };

    data.store = function(testafname) {
        return $q(function (resolve, reject) {
            testafname.group_code = testafname.group_code + "";
            if (testafname.group_code.length > 0) {
                var urlFriendlyValue = encodeURIComponent(
                    testafname.group_code
                );
                Groepscode.all({titel: urlFriendlyValue}).then(function (groepscodes) {
                    if (groepscodes.length > 0) {
                        //groepscode bestaat al, gebruik deze
                        groepscode = groepscodes[0];
                        testafname.groepscode_id = groepscode.id;
                        resolve(realStore(testafname));
                    } else {
                        //create groepscode
                        Ajax.post('groepscode', {titel: testafname.group_code}).then(function (response) {
                            testafname.groepscode_id = response.data.id;
                            resolve(realStore(testafname));
                        });
                    }
                });
            } else {
                //geen groepscode ingevoerd
                resolve(realStore(testafname));
            }
        });
    };

    var realStore = function(testafname) {
        params = {
            _method: 'nieuwe_testafname_uitnodiging',
            achternaam: testafname.kandidaat.achternaam,
            voornaam: testafname.kandidaat.voornaam,
            email: testafname.kandidaat.email,
            taal_id: testafname.kandidaat.taal.id,
            opleidingsniveau_id: testafname.kandidaat.opleidingsniveau.id,
            rapporttemplate_id: (testafname.rapporttemplate ? testafname.rapporttemplate.id : null),
            competentieprofiel_id: (testafname.competentieprofiel ? testafname.competentieprofiel.id : null),
            onderwerp: testafname.mailtemplate.onderwerp,
            inhoud: testafname.mailtemplate.inhoudhtml,
            afzender: testafname.mailtemplate.senderemail,
            cc: testafname.mailtemplate.cc,
            bcc: testafname.mailtemplate.bcc,
            alleen_testotheek: testafname.alleen_testotheek ? 1 : 0,
            verstuurrapport: testafname.stuur_gebruiker_rapport ? 1 : 0,
            verstuurrapport_kandidaat: testafname.stuur_kandidaat_rapport ? 1 : 0,
            groepscode_id: testafname.groepscode_id ? testafname.groepscode_id : null,
            test_ids: []
        };

        if (testafname.competentiegroepen) {
            params.competentiegroep_ids = [];
            angular.forEach(testafname.competentiegroepen, function (competentiegroep) {
                params.competentiegroep_ids.push(competentiegroep.id);
            });
        }

        angular.forEach(testafname.losse_tests, function(losseTest) {
            params.test_ids.push(losseTest.id);
        });

        return $q(function (resolve, reject) {
            Ajax.post('testafname', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };


    data.downloadReport = function(testafname, params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        params._method = 'genereer_rapport';
        params.testafname_id = testafname.id;

        return $q(function (resolve, reject) {
            Ajax.post('testafname', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    data.resendReport = function(testafname, params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        params._method = 'opnieuw_versturen_rapport';
        params.testafname_id = testafname.id;

        return $q(function (resolve, reject) {
            Ajax.post('testafname', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    return data;
});